module.exports = __webpack_public_path__ + "img/xd.44991cf0.png";